import React, { useEffect, useState, useCallback, useMemo } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Popover,
  Tooltip,
  Typography
} from '@material-ui/core';
import { Zap } from 'lucide-react';

import { toast } from 'react-toastify';
import toastError from '../../errors/toastError';
import useSettings from '../../hooks/useSettings';
import ConfirmationModal from '../ConfirmationModal'; // Ajuste o path conforme sua estrutura
import { useStyles } from './style';

const TemporaryMessagesWidget = ({ settings, title, canManage }) => {
  const classes = useStyles();
  const { update } = useSettings();

  // Estados
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentValue, setCurrentValue] = useState('0');

  // Estados para o Modal de Confirmação
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [selectedPendingValue, setSelectedPendingValue] = useState(null);

  const SETTING_KEY = 'excludeClosedTicketsAfter';
  const options = useMemo(() => [15, 30, 60, 90, 180, 365], []);

  useEffect(() => {
    if (Array.isArray(settings)) {
      const setting = settings.find(s => s.key === SETTING_KEY);
      if (setting) {
        setCurrentValue(setting.value?.toString() || '0');
      }
    }
  }, [settings]);

  const handleOpenPopover = (event) => {
    if (!canManage) return;
    setAnchorEl(event.currentTarget);
  };
  const handleClosePopover = () => setAnchorEl(null);

  // 1. Gatilho inicial: Usuário clica no dia, abre o modal de confirmação
  const handleSelectOption = (value) => {
    setSelectedPendingValue(value);
    setConfirmModalOpen(true);
  };

  // 2. Ação final: Após confirmar no Modal, salva no banco
  const handleConfirmUpdate = useCallback(async () => {
    if (!selectedPendingValue) return;

    setLoading(true);
    try {
      await update({
        key: SETTING_KEY,
        value: selectedPendingValue.toString()
      });
      setCurrentValue(selectedPendingValue.toString());
      toast.success('Configuração atualizada com sucesso');
      handleClosePopover(); // Opcional: fecha o popover após sucesso
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
      setSelectedPendingValue(null);
    }
  }, [selectedPendingValue, update]);

  const popoverOpen = Boolean(anchorEl);

  return (
    <>
      <Tooltip title="Mensagens Temporárias">
        <Button
          onClick={handleOpenPopover}
          size="small"
          className={classes.iconButton}
          aria-haspopup="true"
        >
          <Zap size={26} /> {title} Armazenado
        </Button>
      </Tooltip>

      <Popover
        open={popoverOpen}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ className: classes.popoverPaper }}
      >
        {canManage && (
          <>
            <Box className={classes.header}>
              <div className={classes.iconContainer}>
                <Zap size={24} className={classes.zapIcon} />
              </div>
              <Box>
                <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                  Mensagens temporárias
                </Typography>
                <Typography variant="body2" className={classes.infoText}>
                  Configuração de exclusão de tickets.
                </Typography>
              </Box>
            </Box>

            <Typography
              variant="caption"
              style={{ display: 'block', marginBottom: 8, fontWeight: 600, paddingLeft: 8 }}
            >
              Tempo (dias)
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              {options.map(days => (
                <Button
                  key={days}
                  className={`${classes.optionButton} ${currentValue === days.toString() ? 'selected' : ''}`}
                  onClick={() => handleSelectOption(days)}
                  disabled={loading}
                >
                  {loading && selectedPendingValue === days ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    `${days} dias`
                  )}
                </Button>
              ))}
            </Box>

            <Box className={classes.infoBox}>
              <Typography variant="body2">
                Isso vai acelerar o carregamento da página e deixar a navegação mais fluida.
              </Typography>
            </Box>
          </>
        )}

        {/* <Button className={classes.closeButton} onClick={handleClosePopover} fullWidth>
          Fechar
        </Button> */}
      </Popover>

      {/* Modal de Confirmação */}
      <ConfirmationModal
        title="Confirmar Alteração"
        open={canManage && confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={handleConfirmUpdate}
      >
        Ao ativar, as mensagens de todos os atendentes serão excluídas no prazo de
        <strong> {selectedPendingValue} dias</strong> automaticamente. Deseja continuar?
      </ConfirmationModal>
    </>
  );
};

export default TemporaryMessagesWidget;